import GSTInvoice from './GSTInvoice';

export default GSTInvoice;

